const HISTORY_KEY = 'market-stock-search-history';
const MAX_HISTORY = 5;

export function getSearchHistory(): string[] {
  try {
    const history = localStorage.getItem(HISTORY_KEY);
    return history ? JSON.parse(history) : [];
  } catch {
    return [];
  }
}

export function addToSearchHistory(symbol: string): void {
  const history = getSearchHistory();
  const filtered = history.filter(s => s !== symbol);
  const newHistory = [symbol, ...filtered].slice(0, MAX_HISTORY);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(newHistory));
}
